import { ChangeDetectorRef, Component, Input, OnInit, SimpleChanges ,Output,EventEmitter} from '@angular/core'
import { Stringable, StringableValues } from '../../../../../common/stringable.decorator'
import { ConsultationService, DialogService, StateService, VisiteService } from '../../../../../services';
import { JSONRpcResponse } from '../../../../../Interfaces/JSONRpcResponse'
import { formatDate } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { CreateConsultationDialogComponent } from '../../actions/create-consultation-dialog/create-consultation-dialog.component';
import { VisiteActionsDialog } from '../../actions/visite-actions-dialog/visite-actions-dialog.component';
import { of,Observable, Subject  } from 'rxjs'

import { ContextMenu } from "../../../layout/context-menu/icontextmenu.component"

const KEY = 'consultation-calendar'

@Component({
	selector: 'atyl-calendar-monthly',
	templateUrl: './calendar.component.html',
	styleUrls: ['./calendar.component.scss'],
})

@Stringable({
	path: 'views/partials/content/general/calendar-monthly',
	key: KEY,
})
export class CalendarMonthlyComponent implements OnInit {

	@Input() dateLoad: Observable<Date>;
	
    @Input() isvisite: boolean = false; 
    @Input() filtre: any; 
    @Input() isconsultation: boolean = false; 

    @Input() consultationList: any[] = [];
    @Input() currentDate: Date = new Date();
    weeks: any[] = [];
    days = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
    loading: boolean = true; 
    @StringableValues(KEY) strings: any

	@Output() updated = new EventEmitter<any>();
	
	isDisplayContextMenu: any={};
	rightClickMenuItems: Array<ContextMenu> = [];
	
	isDisplayContextConsultMenu: any={};
	rightClickMenuConsultItems : Array<ContextMenu> = [];
	
	rightClickMenuPositionX: number;
	rightClickMenuPositionY: number;
	rightClickStyle: any={};
	
	
	
    constructor(
        private visiteService: VisiteService,
        private consultationService: ConsultationService,
        private changeDetectorRef: ChangeDetectorRef,
        private router: Router,
		private activatedRoute: ActivatedRoute,
        private dialogService: DialogService,
        private stateService: StateService

    ) { }

    ngOnInit(): void {
		this.generateCalendar(this.currentDate);
		this.dateLoad.subscribe((dt: Date) => {
			    if (dt instanceof Date) {
					this.currentDate=dt;
					this.generateCalendar(this.currentDate);
				}	
			})
			
       
        
    }

    

    getConsultationsForDate(date: Date): any[] {
        return this.consultationList.filter(consultation => {
            const consultationDate = new Date(consultation.date_debut);
            return consultationDate.getFullYear() === date.getFullYear() &&
                consultationDate.getMonth() === date.getMonth() &&
                consultationDate.getDate() === date.getDate();
        });
    }

    getConsultationColor(consultation: any): string {
        if (consultation.objectType === 'consultation') {
            return consultation.type.color;
        } else if (consultation.objectType === 'visit') {
            return  consultation.consultation.type.color;
        }
        return "var(--atyl-primary-25)";//#F0F5DE
    }

    
    getConsultationAlpha(consultation: any): number {
       /* let opacity:number= consultation.consultation ?
		consultation.consultation.type.alpha
			:consultation.type.alpha;

		
        if (consultation.objectType === 'consultation') {
            return opacity/=255; 
        } else if (consultation.objectType === 'visit') {
            return opacity-=opacity*25/100;
        }
		
		*/
		if (consultation.objectType === 'consultation') {
			let opacity:number=consultation.type.alpha/255;
			return opacity;	
		}
		else if (consultation.objectType === 'visit') {
			let opacity:number=consultation.consultation.type.alpha/255;
			opacity-=opacity*25/100;
			return opacity;	
		}
        return 1;
    }
    



    generateCalendar(date: Date) {
        const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
        const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    
        // Trouver le lundi avant le début du mois, pour bien démarrer la semaine
        const startDate = this.getStartOfWeek(startOfMonth);
        
        // Trouver le dernier vendredi du mois
        const endDate = this.getEndOfWeek(endOfMonth);
    
        const weeks = [];
        let currentWeek = [];
        let currentDate = startDate;
    
        while (currentDate <= endDate || currentWeek.length > 0) {
            let isCurrentMonth = currentDate.getMonth() === date.getMonth();
    		this.isDisplayContextMenu[this.formatDateToYYYYMMDD(currentDate)]=false;
            // Ajouter le jour actuel au tableau de la semaine
            currentWeek.push({ date: new Date(currentDate), isCurrentMonth });
    
            // Si c'est vendredi, passer directement au lundi suivant
            if (currentWeek.length === 7) {
                weeks.push(currentWeek);
                currentWeek = [];
                currentDate.setDate(currentDate.getDate() + 1); // Passer directement au lundi suivant
            } else {
                // Passer au jour suivant
                currentDate.setDate(currentDate.getDate() + 1);
            }
        }
    
        // Ajouter la dernière semaine si elle est incomplète
        if (currentWeek.length > 0) {
            // Compléter avec des jours du mois suivant si nécessaire
            while (currentWeek.length < 5) {
                currentWeek.push({ date: null, isCurrentMonth: false }); // Placeholder pour les jours vides
            }
            weeks.push(currentWeek);
        }
    
        this.weeks = weeks;
      
    }
    
    
    
    getStartOfWeek(date: Date): Date {
        const day = date.getDay();
        // Ajuste le jour de la semaine pour commencer le lundi
        const diff = date.getDate() - day + (day === 0 ? -6 : 1); 
        return new Date(date.setDate(diff));
    }
    
    getEndOfWeek(date: Date): Date {
        // const lastDay = date.getDate() - date.getDay() + 4; // Fin de la semaine au vendredi (index 4)
        const lastDay = date.getDate() - date.getDay() + 6;
        return new Date(date.setDate(lastDay));
    }
    

    

    firstDayOfMonth(date: string | number | Date){
        date = new Date(date);
        let day = "01";
        let transition = date.getMonth() + 1;
        let month = transition<10?"0"+transition:transition;
        let year = date.getFullYear();
        return  new Date(year+"/"+month+"/"+day);
    }

    lastDayOfMonth(date: string | number | Date){
        date = new Date(date);
        let day = this.getLastDayOfMonth(date);
        let transition = date.getMonth() + 1;
        let month = transition<10?"0"+transition:transition;
        let year = date.getFullYear();
        return  new Date(year+"/"+month+"/"+day);

    }

    getLastDayOfMonth(date: string | number | Date) {
        date = new Date(date);
        let year = date.getFullYear();
        let month = date.getMonth();
        let fulldate = new Date(year, month + 1, 0);
        return fulldate.getDate();
    }

    getProfessionnelName(professionnel: any, type: string): string {
        if (type === 'consultation') {
            return professionnel.NOM+' '+ professionnel.PRENOM;
        } else if (type === 'visit') {
            return professionnel.string;
        }
        return '';
    }

    getLocation(consultation: any): string {
    
        if (consultation.objectType === 'consultation' && consultation.lieu) {
            return consultation.lieu.NOM;
        } else if (consultation.objectType === 'visit' && consultation.consultation && consultation.consultation.lieu) {
            return consultation.consultation.lieu.NOM;
        }
        return '';
    }

    openConsultation(consultation: any){
        const consultationId = consultation.objectType == "visit"? consultation.consultation.ID: consultation.ID;
		const params = consultation.objectType == "visit"
		? {visite: consultation.ID}
		: {}
		this.router.navigate([`/home/consultation/${consultationId}`], {
			relativeTo: this.activatedRoute,
			queryParams: params
		})
    }

    getProfessionnelNames(professionnels: any[], type: string,event:any): string {
        if (type === 'visit') {
            return this.getProfessionnelName(professionnels, type);
        } else if (type === 'consultation') {
            return professionnels.map(professionnel => this.getProfessionnelName(professionnel, type)).join(', ');
        }
		console.log('getProfessionnelNames',event.tiers);
        return (event.tiers!=undefined) ? event.tiers.nom + " "+ event.tiers.prenom :  '';
    }
    
    getTooltipContent(event: any,isHTML:boolean=false): string {
        let date:string = this.formatDateRange(event.date_debut, event.date_fin);
        let location:string = this.getLocation(event);
        let professionals:string = this.getProfessionnelNames(event.professionels, event.objectType,event);
        let tp:any[]=[];
		tp.push(date);
		if (location!='')
			tp.push('Lieu: '+location);
		tp.push('Professionnels: '+professionals);
				
		
		//let tooltipContent:string = `${date}\nLieu: ${location}\nProfessionnels: ${professionals}`;
    
		
		
        if (event.titre && event.titre.length > 0) {
           // tooltipContent += `\nTitre: ${event.titre}`;
			tp.push('Titre: '+event.titre);
        }
       return (isHTML) ? tp.join("<br/>") : tp.join('\n'); 
        //return tooltipContent;
    }
    
    formatDateRange(start: string | Date, end: string | Date): string {
        const startDate = new Date(start);
        const endDate = new Date(end);
        const dateFormatted = startDate.toLocaleDateString('fr-FR');
        const startTime = startDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
        const endTime = endDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
        return `${dateFormatted} de ${startTime} au ${endTime}`;
    }

    formatDateToYYYYMMDD(date: string | Date): string {
        const dateObj = new Date(date);
        
        const year = dateObj.getFullYear();
        const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
        const day = ('0' + dateObj.getDate()).slice(-2);
    
        return `${year}-${month}-${day}`;
    }
    
    openDialog(date: any){
        console.log('openDialog date:',date,'\nisvisite:',this.isvisite,'\nisconsultation:',this.isconsultation,'\nfiltre:',this.filtre);
		if (this.filtre!=undefined) {
	        if(!this.filtre.viewOnly.visit && this.filtre.viewOnly.consult){
	            this.consultationService.getConsultationTypeList().subscribe((res: JSONRpcResponse) => {
	                let dataCs={
	                    action: "create",
	                    dataType: "consultation",
	                    page:"consultation",
	                    title: "Création d'une séance",
	                    create: true,
	                    types:res.result,
	                    dateF: date.date,
	                    startTimeInput: '08:00'
	                }
	                
	                this.dialogService.open(CreateConsultationDialogComponent, {
	                    data: dataCs,
	                    height: "90vh",
	                    width: "80vw",
	                    draggable: true,
	                    maximizable: true,
	                    minimizable: true,
	                    resizable: true,
	                }, () => {
	                    let _refresh={
	                        type: "consultation",
	                        data:dataCs
	                    };
	                    console.log("consultationListe",0)
	                    this.stateService.updateRefresh(_refresh)
	                    this.consultationService
	                    .consultationListe()
	                    .subscribe((cons: JSONRpcResponse) => {
	                        console.log("consult:",cons);
	                        this.changeDetectorRef.detectChanges();
	                    })
	                    this.changeDetectorRef.detectChanges();
	                })
	            })
	        
	        }else if(this.filtre.viewOnly.visit && !this.filtre.viewOnly.consult){
	            let dataVs={
	                action: "create",
	                dataType: "rdv",
	                dateF: this.formatDateToYYYYMMDD(date.date),
	                startTimeInput: '08:00',
	                code: "CREATE_VISITE",
	                dossier: undefined,
	                page:"consultation",
	                title: "Création d'un rendez-vous",
	                create: true,
	            }
	            this.dialogService.open(VisiteActionsDialog, {
	                data: dataVs,
	                height: "95vh",
	                width: "80vw",
	                draggable: true,
	                maximizable: true,
	                minimizable: true,
	                resizable: true,
	            }, (res) => {
	                    console.log(res)
	                
	                    let _refresh={
	                        type: "visite",
	                        data:res
	                    };
	                    
	                    this.stateService.updateRefresh(_refresh)
	                
	                    // console.log("dossier:",this.dossier);
	                    this.visiteService
	                .list() 
	                .subscribe((res: JSONRpcResponse) => {
	                    console.log("view viste",res.result);
	                })
	                this.changeDetectorRef.detectChanges();
	            })
	        }
        }
    }
    
    drop(event) {
        const consultation = event.item.data

        // const previousContainer = event.previousContainer
        const newContainer = event.container

        // const previousDate = previousContainer.data.date
        const newDate = newContainer.data.date
        const todayDate = new Date()

        if (newDate < todayDate) return
        
        const consultationDebut = new Date(consultation.date_debut)
        const consultationFin = new Date(consultation.date_fin)
        
        consultationDebut.setFullYear(newDate.getFullYear())
        consultationDebut.setMonth(newDate.getMonth())
        consultationDebut.setDate(newDate.getDate())

        consultationFin.setFullYear(newDate.getFullYear())
        consultationFin.setMonth(newDate.getMonth())
        consultationFin.setDate(newDate.getDate())

        const options = {
            "datedebut": consultationDebut,
            "datefin": consultationFin,
        }

        this.consultationService.changeDate(consultation.ID, options).subscribe((res: JSONRpcResponse) => {
            
			console.log("CalendarMonthlyComponent  updated",res);
			if (res.result!=undefined)
				this.updated.emit(res.result);
        })
    }
	
	
	displayContextMenu(event:any,day:any,conslt:any=null) {
			event.preventDefault();
		     console.log("displayContextMenu",event,day,this.isDisplayContextMenu);
			 if (conslt) {
				
				if (conslt.objectType=="visit") {
											   this.rightClickMenuConsultItems = [
											     {
											       menuText: '<i class="la la-edit"></i> Rendez-vous',
											       menuEvent: { action:'edit',
													            object:conslt,
																day:day,
															}
											     }
											   ];
					}					   
					else {
						this.rightClickMenuConsultItems = [
						     {
						       menuText: '<i class="la la-edit"></i> Séance',
						       menuEvent: 	 { action:'edit',
							   			       object:conslt,
											   day:day,
							   				},
						     },
							 {
							 		menuText: '<i class="la la-plus"></i> Rendez-vous',
							 		menuEvent: 	{ action:'add',
												  object:conslt,
												  day:day
												},
							  }
							  ];
				}
				Object.keys(this.isDisplayContextConsultMenu).forEach((key) => {
					if (key!=(conslt.objectType+conslt.ID))
						this.isDisplayContextConsultMenu[key]=false;
				});
				if (this.isDisplayContextConsultMenu[conslt.objectType+conslt.ID]!=undefined)
					this.isDisplayContextConsultMenu[conslt.objectType+conslt.ID]=false;
				
				this.isDisplayContextConsultMenu[conslt.objectType+conslt.ID]=!this.isDisplayContextConsultMenu[conslt.objectType+conslt.ID];
				if (this.isDisplayContextMenu[this.formatDateToYYYYMMDD(day.date)]!=undefined
						&& this.isDisplayContextMenu[this.formatDateToYYYYMMDD(day.date)]
						 ) 
						 this.isDisplayContextMenu[this.formatDateToYYYYMMDD(day.date)]=false;
					
				console.log("displayContextMenu counslt",event,day
									,this.rightClickMenuConsultItems,
									conslt,this.isDisplayContextConsultMenu);
								 this.changeDetectorRef.detectChanges();
				
			} else {
				if (this.isDisplayContextMenu[this.formatDateToYYYYMMDD(day.date)]!=undefined ) {
			  	  // this.isDisplayContextMenu = !this.isDisplayContextMenu;
				   this.isDisplayContextMenu[this.formatDateToYYYYMMDD(day.date)]=!this.isDisplayContextMenu[this.formatDateToYYYYMMDD(day.date)];
				  
						
				         
			  	    this.rightClickMenuItems = [
			  			     {
			  			       menuText: '<i class="la la-plus"></i> Séance',
			  			       menuEvent: 	 { action:'seance',
			  				   			       day:day,
											    object:conslt,
			  				   				},
			  			     },
			  				 {
			  				 		menuText: '<i class="la la-plus"></i> Rendez-vous',
			  				 		menuEvent: 	{ action:'visite',
													day:day,
													object:conslt,
									},
			  				  }
			  			]; 
			  		}
			  	   	//this.rightClickMenuPositionX = event.clientX - event.offsetX;
			  	   //	this.rightClickMenuPositionY = event.clientY - event.offsetY;
				  // this.rightClickMenuPositionX = event.pageX;
				 //  this.rightClickMenuPositionY = event.pageY;
				// this.rightClickMenuPositionX = event.pageX-event.clientX
				 //	  this.rightClickMenuPositionY = event.pageY-event.clientY;
				 this.rightClickMenuPositionX =event.pageX-event.clientX;
				 this.rightClickMenuPositionY =event.pageY-event.clientY;
				//  this.rightClickStyle=	 period;
					 
			         console.log("displayContextMenu",event,day
						,this.rightClickMenuItems,
						this.isDisplayContextMenu[this.formatDateToYYYYMMDD(day.date)]);
					 this.changeDetectorRef.detectChanges();
			}	 
		 }

		  	 getRightClickMenuStyle() {
				//let style:any=this.getStylePeriod(this.rightClickStyle);
				//style["position"]="absolute";
				let style:any={
					position: "relative",
		   			"margin-left": "5%",
					"margin-right": "5%",
					display: "block"
				}
				
		  	   return style;
				/*return {
		  	     position: 'fixed',
		  	     left: `${this.rightClickMenuPositionX}px`,
		  	     top: `${this.rightClickMenuPositionY}px`
		  		 
		  			//margin: "5%
		  			//display: "block"
		  	   }*/
		  	 }

		  	 handleMenuItemClick(event) {
		  			event.event.preventDefault();
		  	     console.log("displayContextMenu Click",event);
				 
				 let menuEvent:any=event.data
				 
				 if (menuEvent.object) {
					let  conslt:any=menuEvent.object;
					this.isDisplayContextConsultMenu[conslt.objectType+conslt.ID]=!this.isDisplayContextConsultMenu[conslt.objectType+conslt.ID];
					if (this.isDisplayContextMenu[this.formatDateToYYYYMMDD(menuEvent.day.date)]!=undefined && this.isDisplayContextMenu[this.formatDateToYYYYMMDD(menuEvent.day.date)]  ) 
						this.isDisplayContextMenu[this.formatDateToYYYYMMDD(menuEvent.day.date)]=false;
					this.createFormByPeriod(menuEvent.day,conslt.objectType,conslt)
				 }
				 else {
				// this.isDisplayContextMenu = !this.isDisplayContextMenu;
				if (this.isDisplayContextMenu[this.formatDateToYYYYMMDD(menuEvent.day.date)]!=undefined ) 
					this.isDisplayContextMenu[this.formatDateToYYYYMMDD(menuEvent.day.date)]!=this.isDisplayContextMenu[this.formatDateToYYYYMMDD(menuEvent.day.date)];
			 		this.createFormByPeriod(menuEvent.day,menuEvent.action)
			    }
		  		
		 	}
			
			createFormByPeriod( date: any, type: any,conslt:any=null){
				   let per:string="08:00";
			    
			        if(type == 'seance' || type == 'consultation' ){
			            this.consultationService.getConsultationTypeList().subscribe((res: JSONRpcResponse) => {
			            let dataCs:any={
			                action: "create",
			                dataType: "consultation",
			                code: type,
			                page:"consultation",
			                dateF: this.formatDateToYYYYMMDD(date.date),
							startTimeInput: per,
			                dossier: undefined,
			                title: "Création d'une séance",
			                create: true,
			                types:res.result
			            }
						if (conslt) {
							dataCs["page"]={key:"DOSSIERCONSULATION"};
							this.stateService.updateConsultation(conslt);
							dataCs["dateF"]=undefined;
							dataCs["startTimeInput"]=undefined;
						}
			            console.log("createFormByPeriod",type,dataCs);
			            this.dialogService.open(CreateConsultationDialogComponent, {
			                data: dataCs,
			                height: "95vh",
			                width: "80vw",
			                draggable: true,
			                maximizable: true,
			                minimizable: true,
			                resizable: true,
			            }, () => {
			                let _refresh={
			                    type: "consultation",
			                    data:dataCs
			                };
			                console.log("consultationListe",0)
			                this.stateService.updateRefresh(_refresh)
			                this.consultationService
			                .consultationListe()
			                .subscribe((cons: JSONRpcResponse) => {
			                    console.log("consult:",cons);
			                    this.changeDetectorRef.detectChanges();
			                })
			                this.changeDetectorRef.detectChanges();
			            })
			        })
			        }else if(type == 'visite' || type == 'visit'){
			            let dataVs:any={
			                action: "create",
			                dataType: "rdv",
			                dateF: this.formatDateToYYYYMMDD(date.date),
							startTimeInput: per,
			               code: "CREATE_VISITE",
			                page:"consultation",
			                dossier: undefined,
			                title: "Création d'un rendez-vous",
			                create: true,
			            }
						console.log("createFormByPeriod",type,dataVs);
						if (conslt) {
							dataVs["page"]={key:"DOSSIERCONSULATION"};
							
							
						    this.stateService.updateConsultation(conslt.consultation);
							
							
							let dossier:any={};
								if (conslt.tiers!=undefined) {
									dossier.tiers=conslt.tiers;
									dossier.ID=conslt.tiers.dossierID;
								}
							dataVs["dossier"]=dossier;
							dataVs["title"]="Modification d'un rendez-vous";
							dataVs["dateF"]=undefined;
							dataVs["startTimeInput"]=undefined;
														
						}   
						
						       
			            this.dialogService.open(VisiteActionsDialog, {
			                data: dataVs,
			                height: "95vh",
			                width: "80vw",
			                draggable: true,
			                maximizable: true,
			                minimizable: true,
			                resizable: true,
			            }, (res) => {
			                    console.log(res)
			                
			                    let _refresh={
			                        type: "visite",
			                        data:res
			                    };
			                    
			                    this.stateService.updateRefresh(_refresh)
			                
			                   
			                    this.visiteService
			                .list() 
			                .subscribe((res: JSONRpcResponse) => {
			                    console.log("view viste",res.result);
			                })
			                this.changeDetectorRef.detectChanges();
			            })
			        }
	 }
}
